import Controller from "./plans.controller";
import template from "./plans.html";

const plans = {
  template,
  controller: Controller,
};

export default plans;



// WEBPACK FOOTER //
// ./src/pages/plans/plans.component.js